"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerialCommParameterIds = exports.SerialInitModes = exports.SerialProtocols = void 0;
exports.SerialProtocols = {
    Uart: 0,
    Kwp: 1,
    Tp20: 2,
    IsoTp: 3
};
exports.SerialInitModes = {
    FiveBaud: "five-baud",
    Fast: "fast",
    Unknown: "unknown"
};
exports.SerialCommParameterIds = {
    Protocol: 0x01,
    TesterAddress: 0x02,
    EcuAddress: 0x03,
    TesterCanId: 0x04,
    EcuCanId: 0x05,
    P1: 0x06,
    P2: 0x07,
    P3: 0x08,
    W1: 0x09,
    W2: 0x0a,
    W3: 0x0b,
    W4: 0x0c,
    W5: 0x0d,
    InterByteTime: 0x0e,
    RetryCount: 0x0f,
    TimeoutNr78: 0x10,
    RetryNr78: 0x11,
    InitMode: 0x12,
    SendPulse: 0x13,
    CanFlags: 0x14,
    CanBaudRate: 0x15
};
//# sourceMappingURL=types.js.map